if (!customElements.get('stf-card')) {
  customElements.define(
    'stf-card',
    class STFCard extends HTMLElement {
      constructor() {
        super();
      }

      get video() {
        return this.querySelector('video-element');
      }

      connectedCallback() {
        if (!this.video) return;
        this.addEventListener('mouseleave', this.handleMouseInteraction.bind(this, 'leave'));
        this.addEventListener('mouseenter', this.handleMouseInteraction.bind(this, 'enter'));
      }

      disconnectedCallback() {
        this.removeEventListener('mouseleave');
        this.removeEventListener('mouseenter');
      }

      handleMouseInteraction(type, event) {
        if (type === 'enter') {
          this.classList.add('is-hovering');
          this.video.play();
        } else {
          this.classList.remove('is-hovering');
          this.video.pause();
        }
      }
    }
  );
}

if (!customElements.get('shop-the-feed')) {
  customElements.define(
    'shop-the-feed',
    class ShopTheFeed extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.shop-the-feed__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = parseInt(this.dataset.items);
        this.laptopItems = parseInt(this.dataset.laptopItems);
        this.tabletItems = parseInt(this.dataset.tabletItems);
        this.paginationType = this.dataset.paginationType || 'bullets';

        this.sliderInstance = false;

        if (!this.enableSlider) return;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        if (FoxTheme.config.mqlMobile) {
          this.destroySlider();
        } else {
          this.initSlider();
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;
        const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--f-column-gap');
        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;

        this.sliderOptions = {
          slidesPerView: 2,
          spaceBetween: spaceBetween,
          navigation: {
            nextEl: this.section.querySelector(this.selectors.nextEl),
            prevEl: this.section.querySelector(this.selectors.prevEl),
          },
          pagination: {
            el: this.section.querySelector(this.selectors.pagination),
            type: this.paginationType,
          },
          breakpoints: {
            768: {
              slidesPerView: this.tabletItems > 3 ? 3 : this.tabletItems,
            },
            1024: {
              slidesPerView: this.laptopItems,
            },
            1280: {
              slidesPerView: this.items,
            },
          },
          loop: false,
          threshold: 2,
          watchSlidesProgress: true,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
        };

        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions, [FoxTheme.Swiper.Mousewheel]);
        this.sliderInstance.init();

        const focusableElements = FoxTheme.a11y.getFocusableElements(this);
        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance && this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          });
        });

        if (Shopify.designMode && typeof this.sliderInstance === 'object') {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            let { target } = e;
            const index = Number(target.dataset.index);
            this.sliderInstance.slider.slideTo(index);
          });
        }
      }

      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  );
}

(function () {
  function getYouTubeId(url) {
    const match = url.match(
      /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([^&?/\s]{11})/
    );
    return match ? match[1] : null;
  }

  function getVimeoId(url) {
    const match = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    return match ? match[1] : null;
  }

  // ── 判断视频是否为竖版 ──
  function isPortraitVideo(triggerEl) {
    const ratio = triggerEl.style.getPropertyValue('--aspect-ratio');
    if (ratio) {
      // 支持 "9/16"、"0.5625" 等格式
      if (ratio.includes('/')) {
        const parts = ratio.split('/');
        if (parts.length === 2) {
          return parseFloat(parts[0]) < parseFloat(parts[1]);
        }
      } else {
        return parseFloat(ratio) < 1;
      }
    }
    return false;
  }

  function openModal(modal, triggerEl) {
    const wrap = modal.querySelector('.stf-video-modal__player-wrap');
    const type = triggerEl.dataset.videoType;
    const url = triggerEl.dataset.videoUrl || '';

    // ── 新增：暂停页面上所有卡片的悬浮预览视频 ──
    document.querySelectorAll('.stf-card__media video').forEach(v => {
      v.pause();
      v.currentTime = 0;
    });


    wrap.innerHTML = '';

    if (type === 'youtube') {
      const id = getYouTubeId(url);
      if (!id) return;
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`;
      iframe.allow = 'autoplay; fullscreen';
      iframe.allowFullscreen = true;
      wrap.appendChild(iframe);

    } else if (type === 'vimeo') {
      const id = getVimeoId(url);
      if (!id) return;
      const iframe = document.createElement('iframe');
      iframe.src = `https://player.vimeo.com/video/${id}?autoplay=1`;
      iframe.allow = 'autoplay; fullscreen';
      iframe.allowFullscreen = true;
      wrap.appendChild(iframe);

    } else if (type === 'external') {
      const video = document.createElement('video');
      video.src = url;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      wrap.appendChild(video);
      video.play().catch(() => {});

    } else {
      // Shopify 原生视频
      const sourceVideo = triggerEl.querySelector('video');
      if (!sourceVideo) return;
      const video = document.createElement('video');
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      video.muted = false;
      sourceVideo.querySelectorAll('source').forEach(s => {
        const src = document.createElement('source');
        src.src = s.src;
        src.type = s.type;
        video.appendChild(src);
      });
      if (!video.querySelector('source') && sourceVideo.src) {
        video.src = sourceVideo.src;
      }
      wrap.appendChild(video);
      video.play().catch(() => {});
    }

    // 移动端：根据视频方向动态切换弹窗比例
    const portrait = isPortraitVideo(triggerEl);
    modal.classList.toggle('stf-video-modal--portrait', portrait);

    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeModal(modal) {
    modal.hidden = true;
    modal.classList.remove('stf-video-modal--portrait');
    document.body.style.overflow = '';
    modal.querySelector('.stf-video-modal__player-wrap').innerHTML = '';
  }

  // ── 初始化每个 section ──
  document.querySelectorAll('[id^="shop-the-feed-"]').forEach(section => {
    const sectionId = section.id.replace('shop-the-feed-', '');
    const modal = document.getElementById(`stf-video-modal-${sectionId}`);
    if (!modal) return;

    const content = modal.querySelector('.stf-video-modal__content');

    // ① 关闭按钮
    modal.querySelector('.stf-video-modal__close').addEventListener('click', () => closeModal(modal));

    // ② 点击 __content 外区域关闭
    modal.addEventListener('click', (e) => {
      if (!content.contains(e.target)) closeModal(modal);
    });

    // ③ ESC 键关闭
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.hidden) closeModal(modal);
    });

    // ④ 悬浮自动播放（仅 Shopify 原生视频）
    section.querySelectorAll('[data-video-trigger]').forEach(trigger => {
      if (trigger.dataset.videoType !== 'shopify') return;
      const video = trigger.querySelector('video');
      if (!video) return;
      trigger.addEventListener('mouseenter', () => {
        video.muted = true;
        video.play().catch(() => {});
      });
      trigger.addEventListener('mouseleave', () => {
        video.pause();
        video.currentTime = 0;
      });
    });

    // ⑤ 点击媒体区域打开弹窗；作者链接不在媒体区域内，正常跳转
    section.querySelectorAll('[data-video-trigger]').forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        if (e.target.closest('.stf-card__info-link')) return;
        openModal(modal, trigger);
      });
    });
  }); // 关闭 document.querySelectorAll(...).forEach(section => {)

})();

